export const GetFormattedProductData = (apiResponse = {}) => {
  if (!apiResponse || !apiResponse.data) {
    return {};
  }

  // The data array is directly in apiResponse.data
  const items = apiResponse.data;
  const {
    totalRecords = '',
    totalPages = '',
    currentPage = '',
    pageSize = ''
  } = apiResponse;

  const formattedProducts = items?.map(GetProductData);

  return {
    data: formattedProducts,
    totalRecords,
    totalPages,
    currentPage,
    pageSize
  };
};

// Helper function to map individual product items
const GetProductData = (item = {}) => {
  const {
    productId = null,
    status = null,
    productName = '',
    displayName_en = '',
    displayName_locale = '',
    subCategory_en = '',
    subCategory_locale = '',
    size = '',
    category_en = '',
    category_locale = '',
    brand_en = '',
    brand_locale = '',
    subBrand_en = '',
    subBrand_locale = '',
    included = false
  } = item;

  return {
    productId,
    status,
    productName,
    displayName_en,
    displayName_locale,
    subCategory_en,
    subCategory_locale,
    size,
    category_en,
    category_locale,
    brand_en,
    brand_locale,
    subBrand_en,
    subBrand_locale,
    included
  };
};
